// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1VPO8","colCheckbox":"styles_colCheckbox__30d-c"};